export const products = {
  "Lista kategorii": "Categories list",
  'Ustaw parametr': 'Set parameter',
  'SEO': 'SEO',
  'Status dostępności': "Availability status",
  'Wpisz imię.': 'Enter name.',
  'Wpisz miasto.': 'Enter city.',
  'Opinia musi posiadać conajmniej 10 znaków.': 'Review must have at least 10 chars.',
  'Eksportuj produkty': 'Export products',
  'Sprzedana ilość': 'Total sold',
  'Suma cen sprzedaży': 'Sell price sum',
  'Średnia cena': 'Average price',
  'Brak historii zamówień.': 'No orders.',
  'Package EAN': 'Package EAN',
  'Pokaż wszystkie z grupy': 'Show product group/model',
  'Nieprawidłowe zdjęcie': 'Invalid image',
  'zdjęć ze studia': 'images from photostudio',
  'Ostatnia zmiana': 'Last change at',
  'Docelowa': 'Default',
  'Netto': 'Net',
  'Brutto': 'Gross',
  'Nazwa wyświetlana rozmiaru': "Size's label",
  'Zmień label rozmiaru': "Change size's label",
  'Edytuj label rozmiaru': "Edit size's label",
  'Filtry (niektóre)': 'Filters (some)',
  'Sezon': 'Season',
  'Skopiuj': 'Copy',
  'Razem na stanie': 'Total',
  'Label rozmiaru to nazwa, która zostanie wyświetlona użytkownikowi.': "Size's label is size's name visible for clients",
  'Tutaj możesz np. podmienić wyświetlaną nazwę rozmiaru `uniwersalny` na bardziej konkretny.': "Here you can e.g. overwrite size's label from 'onesize/universal' by more specific value",
  'Wybierz produkty do eksportowania': 'Choose products to export',
  'Wybrane produkty': 'Products selected',
  'Wyeksportowane pola': 'Exported fields',
  'Galeria zdjęć': 'Images gallery',
  '(Zdjęcia przypisane do produktu)': 'Images assigned to product',
  'Przejdź do edycji zdjęć': 'Manage images',
  'Id grupy': 'Pgroup id',
  'Kategoria główna': 'Main category',
  'Pozycja': 'Position',
  'Cena domyślna': 'Default price',
  'Obniżka': 'Sale',
  'Obniżka domyślna': 'Default sale',
  'Opis': 'Description',
  'Uwagi': 'Notes',
  'Na stanie': 'Total',
  'Data aktywowania': 'Activated at',
  'Styl': 'Style',
  '"Płeć" produktu': "Product's \"sex\"",
  "Słowa kluczowe meta": "Meta keywords",
  "Grupa": "Group",
  'Rozmiary': "Sizes",
  'Kolejność zdjęć': 'Images ordering',
  'Nieznana': 'Unknown',
  'Damski': 'Female',
  'Męski': 'Male',
  'Unisex': 'Unisex',
  'Informacje z product catalog': "ProductCatalog's info",
  'Bestseller': 'Bestseller',
  'Tytuł marketingowy': 'Marketing title',
  'Opis marketingowy produktu': 'Marketing description',
  'Produkty w grupie': 'Products in group',
  'Produkt dnia': 'Hot deal',
  'Przeceniono automatycznie': 'Automatically discounted',
  'Nie przeceniaj automatycznie': 'Ignore auto discounting',
  'Cena minimalna sprzedaży': 'Minimal sale price',
  'Best price': 'Best price',
  'Nowe słowo kluczowe...': 'New keyword...',
  'Meta słowa kluczowe': 'Meta keywords',
  'Podaj meta słowa kluczowe': 'Enter meta keywords',
  'Meta opis': 'Meta description',
  'Podaj meta opis': 'Enter meta description',
  'Kup dwa rozmiary większe': 'Suggested 2 sizes larger',
  'Kup dwa rozmiary mniejsze': 'Suggested 2 sizes smaller',
  'Przedsprzedaż': 'Preorder',
  'tytuł': 'title',
  'Zmiana sluga jest niebezpieczna ze względu na SEO, zastanów się 5 razy': 'Changing link/slug can be dangerous, think twice before changing',
  'Nie bez powodu zmiana tytułu aktywnego produktu jest ograniczona w ten sposób - po każdej zmianie nazwy strona musi zadbać o to żeby nie było żadnych problemów z linkowaniem.': 'Changing slug is not trival task - should be used with caution',
  "Zaleca się szczególną ostrożność podczas zmiany nazwy produktu - przycisk 'Edytuj' klikaj tylko po upewnieniu się, że nowa nazwa nie zawiera żadnych błędów.": "Caution advised - be sure that new title does not contains any errors, before you click 'Edit'",
  'Wpisz tytuł': 'Enter title',
  'Porównaj dane': 'Compare data',
  'rozmiar magazynowy': 'warehouse size',
  'Podaj opis meta': 'Enter meta description',
  'Info bazowe na podstawie danych z PC': 'Basic info based on PC data',
  'Filtry': 'Filters',
  'Nazwa atrybutu': 'Attribute name',
  'Kliknij, aby anulować edycję kategorii': "Click to cancel edit categories",
  'Wpisz': 'Enter',
  'ID kategorii PC': "PC's category ID",
  'Skład produktu': 'Product composition',
  'Materiał': 'Material',
  'Procentowy udział materiału w produkcie': '% of material',
  'Cena bazowa sprzedaży': 'Base sale price',
  'Sugerowana cena sprzedaży': 'Suggested sale price',
  'Tabela rozmiarów': 'Sizes table',
  'Powiązane produkty': 'Product set',
  'Wybrane kategorie': 'Selected categories',
  'Możesz wybrać kategorię najniższego poziomu, która zostanie oznaczona jako kategoria główna': 'Selected category-leaf (lowest nest level) that will become main category',
  'Kategoria główna odpowiada m.in. za to, jaki schemat mierzenia wyświetli się na karcie produktu. Prosimy o zaznaczanie jak najbardziej pasującej kategorii głównej.': 'Main category is used e.g. to render valid measurement scheme image. So, please, choose most valid category as main category.',
  "Kategoria główna powinna być kategorią jak najniższego poziomu, tzn produkt który jest i w 'Kozaki' i w 'Kozaki wysokie' (podkategoria 'Kozaki') powinien mieć przypisaną kategorię główną 'Kozaki wysokie'.": "Main category should be category with maximum level, e.g. if product has category 'Boots' and 'High boots', please choose 'High boots', as it's on a deeper level.",
  'Nie udało się wczytać informacji o liście kategorii głównych': 'Failed to load main categories list',
  'Legenda': 'Legend',
  'Ciemnozielony': 'Dark green',
  'Ta kategoria aktualnie jest kategorią główną lub zostanie nią po zapisie': 'That category is main category now, or it\l become after save',
  'Jasnozielony': 'Light green',
  'Po zapisie ta kategoria przestanie być kategorią główną': 'This category will cease to be main category after save',
  'Kliknij, aby anulować edycję zdjęć': 'Click to cancel edit images',
  'Aktywne zdjęcia': 'Images active',
  'Tutaj można ustalać kolejność aktywnych zdjęć': 'Here you can manage order of active images',
  'Wybierz zdjęcia': 'Select images',
  'Zdjęcia ze studia': 'Images from photostudio',
  'Importuj ze studia': 'Import from photostudio',
  "Ubrania": "Clothes",
  "Odzież": "Clothes",
  "Obuwie": "Shoes",
  "Torebki": "Bags",
  "Akcesoria": "Accessories",
  "Biżuteria": "Jewelery",
  "Stroje kąpielowe": "Swimsuits",
  "Nieznany": "Unknown",
  "Portfele": "Wallets",
  "Czapki": "Caps",
  "Szaliki": "Scarves",
  "Rękawiczki": "Gloves",
  "Zegarki": "Watches",
  "Okulary": "Eyeglasses",
  "Kosmetyki": "Beauty accessories",
  "Akcesoria basenowe": "Pool accessories",
  "Rajstopy": "Pantyhose",
  "Skarpetki": "Socks",
  "Naszyjniki": "Necklaces",
  "Kliknij, aby załadować produkty": "Click to load products",
  "Pgroup ID": "Pgroup id",
  "Marża od": "Min margin",
  "Marża do": "Max margin",
  "Outlet": "Outlet",
  "Tutaj można ustalać kolejność aktywnych zdjęć.": "In this section you can sort images",
  "Tutaj możesz wybrać aktywne zdjęcia pośród wszystkich dostępnych na naszych serwerach.": "In this section you can set active images from all available on server images.",
  "Tutaj wyświetlane są zdjęcia ze studia, możliwe do zaimportowania na nasze serwery.": "In this section are displayed all images available to import to store's media server.",
  "Studio nie posiada zdjęć dla tego produktu.": "Photo studio does not provided any images for this product.",
  "Brak dostępnych zdjęć.": "No images available",
  "Zapisz aktualną kolejność na stałe": "Set actual images order as persistent.",
  "Kolejność zdjęć podczas importowania": "Images order",
  "Edytuj kolejność importowania": "Edit images order",
  "kolejność zdjęć ustawiona tutaj nie jest stała, zostanie zresetowana przy kolejnej zmianie zdjęć przez studio.": "images ordering set here is not persistent, it would be reset on images importing from photo-studio",
  'Aby ustawić stałą kolejność zdjęć, użyj opcji "Edytuj kolejność importowania".': 'To persist images order, use button "Edit images order"',
  "Numery zdjęć:": "Images slots:",
  "Brak reguł kolejności": "No images ordering rules",
  "Slot": "Slot",
  "Brak aktywnych zdjęć": "No active images.",
  "gdy zdjęcie {{slot}} nie istnieje": "when slot {{slot}} does not exist",
  "Typ listy": "List type",
  "Uwaga! Przy obecnie ustawionej ilości produktów na stronę ({{productsPerPage}}) przejście na starą wersję listy produktów może okazać się czasochłonne dla Twojego komputera. Kontynuować?": "Warning! With actual page size ({{productsPerPage}}) changing list type to default can hang your browser. Do you want to continue?",
  "Fashion": "Fashion",
  "Standard": "Standard",
  "Stała oferta": "Standing offer",
  "Sale": "Sale",
  "Styl (z PC)": "Style (from PC)",
  "Data ostatniej dostawy": "Last delivery date",
  "Inne informacje": "Other informations",
  "Możliwość zwrotu": "Returns allowed",
  "Package EANy": "Package EANs",
  "Wyszukaj po package ean'ach": "Search by package eans",
  "Normalna wersja listy produktów": "Normal list",
  "Szybsza, eksperymentalna wersja listy": "Experimental list",
  "Produkt jest częścią programu AZAConnect": "AZAConnect product",
  "Numer rozmiaru w WH": "WH size no.",
  "Nazwa rozmiaru sprzed unifikacji": "Maker size",
  "Ten rozmiar nie jest zunifikowany": "This size is not unified",
  "Pełna unifikacja": "Fully unified",
  "Link produktu na stronie zostanie utworzony na podstawie tytułu, upewnij się przed zapisaniem.": "Product link will be generated from it's title. Check it double before saving.",
}



// WEBPACK FOOTER //
// ./locales/en_US/products.js